import ContactCard from "../../features/Contact/ContactCard/ContactCard";
import './Contact.css';
import MainLayout from "../../layouts/MainLayout/MainLayout";
import { useLocation } from "react-router";
import { Helmet } from "react-helmet";

const Contact = () => {
    const { state: courseData } = useLocation();

    return (

        <>
            <Helmet>
                <title>FORVET | Contacto</title>
                <meta name="description"
                    content="En FORVET estamos siempre con vos. Por eso podes hablar con nosotros en cualquier momento." />
                <meta property="og:title" content="FORVET | Contacto" />
                <meta property="og:description"
                    content="En FORVET estamos siempre con vos. Por eso podes hablar con nosotros en cualquier momento." />
            </Helmet>
            <MainLayout overflow="hidden">
                <section className="contact-section">
                    <ContactCard courseData={courseData} />
                </section>
            </MainLayout>
        </>
    )
}
export default Contact